import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgMessagesSelectedNavIconSecondary(props) {
  return jsx("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M15.272 3H4.737A4.75 4.75 0 0 0 0 7.737v5.389a4.744 4.744 0 0 0 4.737 4.737h10.526A4.744 4.744 0 0 0 20 13.126V7.737C20.01 5.131 17.878 3 15.272 3ZM4.867 12.363a1.93 1.93 0 0 1-1.926-1.927A1.93 1.93 0 0 1 4.867 8.51a1.93 1.93 0 0 1 1.927 1.926 1.93 1.93 0 0 1-1.927 1.927Zm5.138 0a1.93 1.93 0 0 1-1.927-1.927 1.93 1.93 0 0 1 1.927-1.926 1.93 1.93 0 0 1 1.926 1.926 1.93 1.93 0 0 1-1.926 1.927Zm5.137 0a1.93 1.93 0 0 1-1.927-1.927 1.93 1.93 0 0 1 1.927-1.926 1.93 1.93 0 0 1 1.926 1.926 1.93 1.93 0 0 1-1.926 1.927Z",
    fill: "currentColor"
  }));
}

export { SvgMessagesSelectedNavIconSecondary as default };
